import React, { useState } from "react";
import { FaShare, FaTimes, FaWhatsapp, FaLinkedinIn, FaFacebookF, FaTwitter, FaUserFriends } from "react-icons/fa";

const SHARE_URL = typeof window !== 'undefined' ? window.location.origin : "https://asdflow.com";
const SHARE_TITLE = "Join asdflo – India's neurodiversity platform (Free for 3 months!)";
const SHARE_TEXT = `Discover asdflo: India's most vibrant neurodiversity platform connecting parents, professionals & centers. Sign up now for 3 months free!\n${SHARE_URL}\n\n#neurodiversity #autism #inclusion #sitarejameenpar #asdflo`;

const ENCODED_TITLE = encodeURIComponent(SHARE_TITLE);
const ENCODED_TEXT = encodeURIComponent(SHARE_TEXT);
const ENCODED_URL = encodeURIComponent(SHARE_URL);

const LINKS = {
  whatsapp: `https://wa.me/?text=${ENCODED_TEXT}`,
  linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${ENCODED_URL}&title=${ENCODED_TITLE}&summary=${ENCODED_TEXT}`,
  facebook: `https://www.facebook.com/sharer/sharer.php?u=${ENCODED_URL}&quote=${ENCODED_TEXT}`,
  twitter: `https://twitter.com/intent/tweet?text=${ENCODED_TEXT}`,
};

function isMobile() {
  if (typeof window === 'undefined') return false;
  return /Mobi|Android|iPhone/i.test(window.navigator.userAgent);
}

const ReferAndShareCTA = ({ onReferClick, className = '' }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: SHARE_TITLE,
          text: SHARE_TEXT,
          url: SHARE_URL,
        });
      } catch (err) {
        // User cancelled or error
      }
    }
  };

  const copyLink = () => {
    navigator.clipboard.writeText(SHARE_URL);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  if (isMobile() && !isExpanded) {
    return (
      <button
        onClick={toggleExpand}
        className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-gradient-to-r from-sky-500 to-blue-600 rounded-full shadow-xl flex items-center justify-center text-white hover:shadow-2xl transition-all duration-300"
        aria-label="Share or refer"
      >
        <FaShare size={20} />
      </button>
    );
  }

  return (
    <div className={`fixed bottom-24 right-4 sm:right-8 ${isExpanded ? 'w-72' : 'w-14'} z-40 transition-all duration-300`}>
      <div className="bg-white rounded-xl shadow-2xl overflow-hidden transition-all duration-300 border border-gray-100 relative z-40 w-full transform hover:scale-105 hover:shadow-lg">
        {isExpanded && (
          <div className="p-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-semibold text-gray-800">Spread the Word</h3>
              <button 
                onClick={toggleExpand}
                className="text-gray-400 hover:text-gray-600"
                aria-label="Close"
              >
                <FaTimes size={16} />
              </button>
            </div>
            
            <div className="space-y-3">
              <button
                onClick={onReferClick}
                className="w-full flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-500 to-sky-600 text-white rounded-lg font-medium hover:opacity-90 transition-opacity"
              >
                <FaUserFriends className="flex-shrink-0" />
                <span>Refer Someone</span>
              </button>

              <div className="flex items-center gap-2">
                <div className="h-px bg-gray-100 flex-1"></div>
                <span className="text-xs text-gray-400">OR SHARE</span>
                <div className="h-px bg-gray-100 flex-1"></div>
              </div>

              <div className="grid grid-cols-4 gap-2">
                <a
                  href={LINKS.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 bg-green-100 text-green-600 rounded-lg flex items-center justify-center hover:bg-green-200 transition-colors"
                  aria-label="Share on WhatsApp"
                >
                  <FaWhatsapp size={20} />
                </a>
                <a
                  href={LINKS.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 bg-blue-50 text-blue-700 rounded-lg flex items-center justify-center hover:bg-blue-100 transition-colors"
                  aria-label="Share on LinkedIn"
                >
                  <FaLinkedinIn size={20} />
                </a>
                <a
                  href={LINKS.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center hover:bg-blue-100 transition-colors"
                  aria-label="Share on Facebook"
                >
                  <FaFacebookF size={20} />
                </a>
                <a
                  href={LINKS.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 bg-sky-50 text-sky-500 rounded-lg flex items-center justify-center hover:bg-sky-100 transition-colors"
                  aria-label="Share on Twitter"
                >
                  <FaTwitter size={20} />
                </a>
              </div>

              <div className="relative mt-2">
                <input
                  type="text"
                  readOnly
                  value={SHARE_URL}
                  className="w-full pr-16 pl-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <button
                  onClick={copyLink}
                  className="absolute right-1.5 top-1/2 -translate-y-1/2 px-3 py-1 text-xs bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 transition-colors"
                >
                  {copied ? 'Copied!' : 'Copy'}
                </button>
              </div>
            </div>
          </div>
        )}
        
        {!isExpanded && (
          <button
            onClick={toggleExpand}
            className="w-14 h-14 bg-gradient-to-r from-sky-500 to-blue-600 flex items-center justify-center text-white hover:opacity-90 transition-opacity"
            aria-label="Share or refer"
          >
            <FaShare size={20} />
          </button>
        )}
      </div>
    </div>
  );
};

export default ReferAndShareCTA;
